/**
 * Tour step definitions for the Galaxy View walkthrough.
 *
 * Each step defines:
 *   target  – CSS selector for the element to spotlight (null = centered modal)
 *   title   – short heading
 *   text    – description
 *   placement – preferred tooltip position relative to target
 */
const TOUR_STEPS = [
  {
    target: null,
    title: 'Welcome to your Galaxy',
    text: 'Each glowing node is an artist. Brighter and larger nodes are more relevant to your seeds. Click any node to explore.',
    placement: 'center',
  },
  {
    target: null,
    title: 'Artist Actions',
    text: 'When you click a node, the detail panel gives you three actions - favorite, neutral, or dislike - plus play previews, open in Spotify, or queue the artist as a new seed to regenerate your map.',
    placement: 'center',
  },
  {
    target: '.galaxy-player-start-button',
    title: 'Explore Mode',
    text: 'Auto-play through your galaxy — the camera drifts from artist to artist while previewing tracks.',
    placement: 'top',
  },
  {
    target: '.toolbar-actions-group .toolbar-pill:nth-child(2)',
    title: 'Playlist',
    text: 'View all of the artist previews as a playlist. Open any song in Spotify.',
    placement: 'top',
  },
  {
    target: '.toolbar-actions-group .toolbar-pill:first-child',
    title: 'Share',
    text: 'Share your galaxy with friends so they can explore your musical map.',
    placement: 'top',
  },
  {
    target: '.expand-universe-btn',
    title: 'Expand Galaxy',
    text: 'Discover genre-adjacent outlier artists beyond your core galaxy. These "drift" nodes orbit the edges and reveal new musical territory.',
    placement: 'bottom',
  },
  {
    target: null,
    title: 'My Universe',
    text: 'Your Universe is a living collection of every artist you favorite and discover across all your galaxies. Visit it from the home screen to see your full musical map grow over time.',
    placement: 'center',
  },
  {
    target: null,
    title: 'Collide with Friends',
    text: 'From the home screen, add friends and hit "Collide" to compare your music taste — see overlapping favorites, shared frontiers, and new artists to explore together.',
    placement: 'center',
  },
];

export default TOUR_STEPS;
